module.exports = __webpack_public_path__ + "img/jacob_peters.jpeg";